var _defs, _g, _rect, _rect2, _rect3, _rect4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBattery100(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        stroke-linecap: round;\n        stroke-linejoin: round;\n      }\n\n      .st0, .st1 {\n        fill: #fff;\n        stroke: #02222b;\n        stroke-width: 6px;\n      }\n\n      .st2 {\n        fill: #047290;\n      }\n\n      .st1 {\n        stroke-miterlimit: 10;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    x: 26.7,
    y: 17.9,
    width: 45,
    height: 74.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M36.2,7.9h26.1c1,0,1.8.9,1.8,2.1v5.1c0,1.1-.8,2.1-1.8,2.1h-26.1c-1,0-1.8-.9-1.8-2.1v-5.1c0-1.1.8-2.1,1.8-2.1Z"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st2",
    x: 32.7,
    y: 73.6,
    width: 33,
    height: 12.4,
    rx: 1.8,
    ry: 1.8
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "st2",
    x: 32.7,
    y: 57.2,
    width: 33,
    height: 12.4,
    rx: 1.8,
    ry: 1.8
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "st2",
    x: 32.7,
    y: 40.8,
    width: 33,
    height: 12.4,
    rx: 1.8,
    ry: 1.8
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "st2",
    x: 32.7,
    y: 24.4,
    width: 33,
    height: 12.4,
    rx: 1.8,
    ry: 1.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBattery100);
export default __webpack_public_path__ + "static/media/battery100.8542f3af6a29113c6c06a207be6da769.svg";
export { ForwardRef as ReactComponent };